const videos = document.querySelectorAll(".article__iframe-video");

if (videos) {
  for (var i; i < videos.length; i++) {
    const video = videos[i];

    let videoParent = video.parentElement;
    videoParent.removeChild(video);

    window.addEventListener("scroll", function() {
      if (
        window.scrollY < videoParent.offsetTop + videoParent.offsetHeight &&
        window.scrollY + window.outerHeight > videoParent.offsetTop
      ) {
        if (videoParent.children.length == 0) {
          videoParent.appendChild(video);
        }
      }
    });
  }
}
